export default {
  GET_KC_SEARCH_REQUESTED: 'GET_KC_SEARCH_REQUESTED',
  GET_KC_SEARCH_SUCCEEDED: 'GET_KC_SEARCH_SUCCEEDED',
  GET_KC_SEARCH_FAILED: 'GET_KC_SEARCH_FAILED',
};
